import { CheckoutFacialRecognitionProcess } from 'modules/checkout/infra/adapters';
import { makeStorageProvider } from 'shared/infra/providers';

export default function registerValidFacialRecognition(params: {
  budgetId: number;
  customerId: number;
}) {
  const storage = makeStorageProvider();

  const storedProcesses = storage.get('VALID_FACIAL_RECOGNITIONS') || [];

  storedProcesses.push(new CheckoutFacialRecognitionProcess(params));

  try {
    storage.store('VALID_FACIAL_RECOGNITIONS', storedProcesses);
  } catch {
    // `setItem` lança em aba anônima, e quem chama está no callback de sucesso do facial:
    // deixar subir travaria o cliente numa tela já aprovada.
  }
}
